import { isOtherDomain } from '@autobid/ui/utils/isOtherDomain'
import { parseLinkToRelative } from '@autobid/ui/utils/parseLinkToRelative'

// todo: remove the validateUrl function after upgrade to nuxt >=4.4.6
// context: https://github.com/nuxt/nuxt/security/advisories/GHSA-fx6j-w5w5-h468
export function validateUrl(link: string, baseUrl: string): string | null {
  try {
    const normalised = new URL(link, link.startsWith('http') ? undefined : baseUrl).toString()

    if (link.includes('<') || link.includes('>')) {
      return null
    }

    return normalised
  }
  catch {
    return null
  }
}

export function useOpenLink() {
  const { push } = useRouter()
  const { SELF_URL } = useRuntimeConfig().public

  const open = (link: string, otherDomainInNewTab?: boolean) => {
    const safeLink = validateUrl(link, SELF_URL)

    if (!safeLink) {
      return
    }

    if (isOtherDomain(safeLink)) {
      navigateTo(safeLink, {
        external: true,
        open: otherDomainInNewTab
          ? {
              target: '_blank',
            }
          : undefined,
      })
    }
    else {
      // get a path from the absolute link
      const path = parseLinkToRelative(safeLink)
      const hash = path.match(/#(.*)$/)?.[1] || undefined

      push({ path, hash: hash ? `#${hash}` : undefined })
    }
  }

  return { open }
}
